import { render, staticRenderFns } from "./StatTile.vue?vue&type=template&id=0b89b288&scoped=true&"
import script from "./StatTile.vue?vue&type=script&lang=js&"
export * from "./StatTile.vue?vue&type=script&lang=js&"
import style0 from "./StatTile.vue?vue&type=style&index=0&id=0b89b288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89b288",
  null
  
)

export default component.exports